var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1507 10.8496L4 24.0003L17.1507 37.151",
    stroke: "#7743DB",
    strokeWidth: 4.69863
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2242 39V10.8082H29.4598V39H24.2242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8386 23.7764H55.8942V28.2066H41.8386V23.7764ZM42.2816 39H37.046V10.8082H57.626V15.1981H42.2816V39Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5296 39.2819C59.6168 39.2819 58.8381 38.9732 58.1937 38.3556C57.5494 37.7112 57.2272 36.9058 57.2272 35.9392C57.2272 34.9189 57.5494 34.1134 58.1937 33.5227C58.8381 32.9052 59.6168 32.5964 60.5296 32.5964C61.4425 32.5964 62.2211 32.9052 62.8655 33.5227C63.5099 34.1134 63.8321 34.9189 63.8321 35.9392C63.8321 36.9058 63.5099 37.7112 62.8655 38.3556C62.2211 38.9732 61.4425 39.2819 60.5296 39.2819Z",
    fill: "#7743DB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.c258be8d3015b7319528cc84dda0fa93.svg";
export { ForwardRef as ReactComponent };